import React, { useEffect, useMemo, useState } from "react";
import ApiConfig from "../../common/config/ApiConfig";
import { useCurrency } from "../../common/CurrencyContext";
import { formatBetNumber } from "../../common/utils/formatBetNumber";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { motion } from "framer-motion";
import Typography from "@mui/material/Typography";
import LoadingComponent from "../LoadingComponent"; // Replace with the correct path
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DoNotTouchIcon from "@mui/icons-material/DoNotTouch";
import "./orderlist.css";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import Swal from "sweetalert2";
import { SWAL_THEME } from "../../common/utils/swalTheme";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const LIMIT = 6;

export default function Orders() {
  const { t } = useTranslation();
  const currency = useCurrency();
  const [order, setOrder] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [Modalloading, setModalLoading] = useState(true); // Loading state
  const [orderid, setOrderid] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const user = localStorage.getItem("user");
  //console.log(order)

  const OrderGet = (currentPage) => {
    setLoading(true);
    const jsonData = {
      username: user,
      page: currentPage,
      limit: LIMIT,
    };
    ApiConfig.post("/orderlist", jsonData).then((result) => {
      if (result.resCode === 200) {
        setOrder(result.data);
        setTotal(result.total || 0);
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    OrderGet(page);
    // eslint-disable-next-line
  }, [page]);

  const [rewardTypeGroups, setRewardTypeGroups] = useState([]);

  useEffect(() => {
    ApiConfig.get("/getLottoRewardTypeGroups").then((res) => {
      if (res.resCode === 200) {
        setRewardTypeGroups(res.data);
      }
    });
  }, []);

  // code -> { name, groupName }, so bet lines can show both their own
  // label and the section header (e.g. "3 ตัวบน" under group "3 ตัว").
  const rewardTypeInfo = useMemo(() => {
    const info = {};
    rewardTypeGroups.forEach((group) => {
      group.rewardTypes.forEach((rewardType) => {
        info[rewardType.code] = {
          name: rewardType.name,
          groupName: group.name,
        };
      });
    });
    return info;
  }, [rewardTypeGroups]);

  const totalPages = total > 0 ? Math.ceil(total / LIMIT) : 0;

  //////////////////////// show by id in modal /////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  const [open, setOpen] = React.useState(false);
  const [resdate, setResdate] = React.useState("");
  const [betdate, setBetdate] = React.useState("");
  const [totalbet, setTotalbet] = React.useState("");
  const [totalwin, setTotalwin] = React.useState("");
  const [pollid, setPollid] = React.useState("");

  const handleClickOpen = (id, rdate, bdate, tbet, twin, type, round) => {
    setModalLoading(true);
    const jsonid = {
      orderid: id,
    };
    setOpen(true);
    setResdate(rdate);
    setBetdate(bdate);
    setTotalbet(tbet);
    setTotalwin(twin);
    setPollid(id);
    ApiConfig.post("/orderid", jsonid).then((result) => {
      if (result.resCode === 200) setOrderid(result.data);
      setModalLoading(false);
    });
  };

  const handleClose = () => {
    setOpen(false);
    setResdate("");
    setBetdate("");
    setTotalbet("");
    setTotalwin("");
    setPollid("");
  };

  function refreshPage() {
    window.location.reload(false);
  }

  const handleDelete = (id) => {
    // Show confirmation dialog to the user
    Swal.fire({
      ...SWAL_THEME,
      title: t("orderList.confirmCancel.title"),
      text: t("orderList.confirmCancel.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("orderList.confirmCancel.confirmButton"),
      cancelButtonText: t("orderList.confirmCancel.cancelButton"),
    }).then((result) => {
      if (result.isConfirmed) {
        const jsonData = {
          id: id,
          username: user,
        };
        console.log(jsonData);
        ApiConfig.post("/cancel", jsonData)
          .then((response) => {
            if (response.resCode === 200) {
              // Show success message
              toast.success(t("orderList.toast.cancelSuccess"));
              // Refresh the page
              refreshPage();
            } else {
              // Handle server error
              throw new Error("Server Error");
            }
          })
          .catch((error) => {
            // Show error message
            toast.error(t("orderList.toast.cancelError"));
            console.error(error);
          });
      }
    });
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="flex flex-col w-[100%] h-[auto] bg-gradient-to-r from-brand-blue-800 from-30% via-brand-blue-700 via-50% to-brand-blue-900 to-90%  justify-center"
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="flex flex-col justify-center">
          <div className="w-[100%] flex flex-row items-center h-[48px] p-2 px-4 bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b border-brand-gold-300/40 space-x-2 rounded-t-lg shadow-card">
            <ContentPasteSearchIcon
              className="text-brand-gold-300"
              fontSize="small"
            />
            <span className="text-brand-gold-200 font-bold font-heading text-m tracking-wide">
              {t("orderList.header")}
            </span>
          </div>
          {loading ? (
            <LoadingComponent />
          ) : (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="flex flex-col justify-center border-[1px] overflow-x-auto border-brand-gold-300/30 p-1 w-[100%] h-[auto] drop-shadow-2xl"
            >
              <Grid container spacing={2}>
                {order.map((row) => (
                  <Grid item xs={12} sm={6} md={4} key={row.id}>
                    <Card className="!rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-200">
                      <CardContent className="flex flex-col space-y-2 bg-slate-100">
                        <Typography variant="h5" component="div">
                          <div className="flex flex-col space-y-2">
                            <div className="w-[100%] relative justify-center text-center shadow-md bg-gradient-to-r from-brand-blue-700 via-brand-blue-600 to-brand-blue-700 rounded-t-lg py-1">
                              <span className="text-xs text-white/90 font-semibold tracking-wide">
                                {t("orderList.orderDetail.orderNumberCard", {
                                  id: row.id,
                                })}
                              </span>
                              <div className="absolute top-1 right-1">
                                {row.status === "wait_result" && (
                                  <div className="inline-flex flex-row border-white text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-amber-400 to-amber-500 shadow-sm">
                                    <span className="text-white text-[12px] font-bold">
                                      {t("orderList.status.waitResult")}
                                    </span>
                                  </div>
                                )}
                                {row.status === "lose" && (
                                  <div className="inline-flex flex-row border-white text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-rose-500 to-red-600 shadow-sm">
                                    <span className="text-white text-[12px] font-bold">
                                      {t("orderList.status.lose")}
                                    </span>
                                  </div>
                                )}
                                {row.status === "cancel" && (
                                  <div className="inline-flex flex-row border-white text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-slate-500 to-slate-600 shadow-sm">
                                    <span className="text-white text-[12px] font-bold">
                                      {t("orderList.status.cancel")}
                                    </span>
                                  </div>
                                )}
                                {row.status === "win" && (
                                  <div className="inline-flex flex-row border-white text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-emerald-400 to-green-600 shadow-sm">
                                    <span className="text-white text-[12px] font-bold">
                                      {t("orderList.status.win")}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="flex space-x-1 p-2 rounded-sm flex-row bg-slate-200">
                                <div className="w-[50%]">
                                  <div className="flex flex-wrap gap-1">
                                    {row.type === "th_gov" && (
                                      <div className="inline-flex border-brand-gold-300/50 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm">
                                        <span className="text-brand-gold-200 text-[13px] font-semibold">
                                          {t("orderList.types.thGov")}
                                        </span>
                                      </div>
                                    )}
                                    {row.type === "hanoy_PhuQua" && (
                                      <div className="inline-flex border-brand-gold-300/50 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm">
                                        <span className="text-brand-gold-200 text-[13px] font-semibold">
                                          {t("orderList.types.hanoi")}
                                        </span>
                                      </div>
                                    )}
                                    {row.type === "laos_gov" && (
                                      <div className="inline-flex border-brand-gold-300/50 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm">
                                        <span className="text-brand-gold-200 text-[13px] font-semibold">
                                          {t("orderList.types.laos")}
                                        </span>
                                      </div>
                                    )}
                                    {row.type === "Yeekee_5" && (
                                      <div className="inline-flex border-brand-gold-300/50 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm">
                                        <span className="text-brand-gold-200 text-[13px] font-semibold">
                                          {t("orderList.types.yeekeeNormal")}
                                        </span>
                                      </div>
                                    )}
                                    {row.type === "Yeekee_10" && (
                                      <div className="inline-flex border-brand-gold-300/50 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm">
                                        <span className="text-brand-gold-200 font-bold text-[13px]">
                                          {t("orderList.types.yeekeeVip")}
                                        </span>
                                      </div>
                                    )}
                                    {row.type === "Yeekee_15" && (
                                      <div className="inline-flex border-brand-gold-300 text-center justify-center border-[2px] w-auto px-2 py-1 h-auto rounded-full bg-gradient-to-r from-brand-blue-700 to-brand-blue-900 shadow-sm">
                                        <span className="text-brand-gold-200 font-bold text-[13px]">
                                          {t("orderList.types.yeekeeVvip")}
                                        </span>
                                      </div>
                                    )}
                                    {row.round &&
                                      row.type !== "th_gov" &&
                                      row.type !== "laos_gov" && (
                                        <div className="inline-flex border-brand-blue-300 text-center justify-center border-[1px] w-auto px-2 py-1 h-auto rounded-full bg-white shadow-sm">
                                          <span className="text-brand-blue-700 text-[13px] font-semibold">
                                            {t("orderList.roundNumber", {
                                              round: row.round,
                                            })}
                                          </span>
                                        </div>
                                      )}
                                  </div>

                                  <div className="res mt-1">
                                    <div className="md:w-[100%] text-center bg-white rounded-full place-content-center border-[1px] border-slate-300 flex justify-center px-2 py-0.5">
                                      <span className="text-slate-600 text-[12px]">
                                        {t("orderList.buyDate")}{" "}
                                        {row.buydate &&
                                          moment(row.buydate).format("ll")}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="w-[50%] flex flex-col">
                                  <div align="right">
                                    <div className="font-bold res space-x-2 mt-1">
                                      <p className="text-[14px] text-slate-500">
                                        {t("orderList.winLoss")}
                                      </p>
                                      <span
                                        className={
                                          parseFloat(row.totalwin) > 0
                                            ? "text-green-600"
                                            : "text-red-600"
                                        }
                                      >
                                        {row.totalwin}{currency?.symbol}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="pad">
                              <div className="md:w-[100%] bg-white p-2 rounded-lg border-[1px] border-slate-200 flex justify-between shadow-sm">
                                <div className="flex flex-row items-center space-x-1">
                                  <span className="text-[14px] text-slate-500">
                                    {t("orderList.totalBet")}
                                  </span>
                                  <span className="text-[18px] text-brand-gold-600 font-bold">
                                    {row.totalbet}{currency?.symbol}
                                  </span>
                                </div>
                                <div className="flex flex-row items-center space-x-2">
                                  <span className="text-[14px] text-slate-500">
                                    {t("orderList.roundDate")}
                                  </span>
                                  <span className="text-[13px] text-brand-blue-700 font-bold">
                                    {row.resultdate &&
                                      moment(row.resultdate).format("ll")}
                                    {row.round !== 1 && (
                                      <>
                                        {" "}
                                        |{" "}
                                        {t("orderList.roundNumber", {
                                          round: row.round,
                                        })}
                                      </>
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="flex flex-col w-full space-y-2">
                              <div
                                className="pad flex flex-row space-x-1"
                                align="right"
                              >
                                {row.status === "wait_result" && (
                                  <button
                                    onClick={() => handleDelete(row.id)}
                                    className="flex flex-row items-center justify-center gap-1 bg-white border border-brand-gold-300 w-full text-red-600 hover:bg-red-500 hover:text-white hover:border-brand-gold-500 text-[13px] font-semibold py-2 px-3 rounded-lg shadow-sm transition-colors"
                                  >
                                    <DoNotTouchIcon fontSize="small" />{" "}
                                    {t("orderList.returnOrder")}
                                  </button>
                                )}
                                <button
                                  onClick={() =>
                                    handleClickOpen(
                                      row.id,
                                      row.resultdate,
                                      row.buydate,
                                      row.totalbet,
                                      row.totalwin,
                                      row.type,
                                      row.round,
                                    )
                                  }
                                  className="flex flex-row items-center justify-center gap-1 bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 shadow-sm w-full text-white hover:from-brand-blue-500 hover:to-brand-blue-700 text-[13px] font-semibold py-2 px-3 rounded-lg border-2 border-brand-gold-300 ring-2 ring-brand-gold-300 ring-offset-2 ring-offset-slate-100 transition-colors"
                                >
                                  <ContentPasteSearchIcon fontSize="small" />{" "}
                                  {t("orderList.viewOrder")}
                                </button>
                              </div>
                            </div>
                          </div>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {(totalPages > 1 || order.length > 0) && (
                <div className="flex items-center justify-between mt-3 px-2">
                  <span className="text-sm font-semibold text-brand-blue-700 bg-brand-blue-50 px-3 py-1 rounded-full border border-brand-blue-200">
                    {t("orderList.pagination.page")} {page}
                    {totalPages > 0 ? ` / ${totalPages}` : ""}
                    {total > 0 &&
                      ` · ${t("orderList.pagination.items", { count: total })}`}
                  </span>
                  <div className="flex space-x-1">
                    <button
                      onClick={() => setPage(1)}
                      disabled={page === 1}
                      className="px-2 py-1 text-xs font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      «
                    </button>
                    <button
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                      disabled={page === 1}
                      className="px-3 py-1 text-xs font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      {t("orderList.pagination.prev")}
                    </button>
                    <span className="px-3 py-1 text-xs font-bold rounded bg-brand-blue-600 text-brand-gold-200 select-none">
                      {page}
                    </span>
                    <button
                      onClick={() => setPage((p) => p + 1)}
                      disabled={totalPages > 0 && page >= totalPages}
                      className="px-3 py-1 text-xs font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      {t("orderList.pagination.next")}
                    </button>
                    {totalPages > 0 && (
                      <button
                        onClick={() => setPage(totalPages)}
                        disabled={page >= totalPages}
                        className="px-2 py-1 text-xs font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                      >
                        »
                      </button>
                    )}
                  </div>
                </div>
              )}

              {open && (
                <div>
                  <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={isMobile ? true : false}
                    fullScreen={isMobile ? true : false}
                  >
                    <DialogTitle
                      className="text-brand-gold-200 bg-gradient-to-r from-brand-blue-800 via-brand-blue-700 to-brand-blue-800 border-b border-brand-gold-300/40 font-bold font-heading"
                      id="alert-dialog-title"
                    >
                      {t("orderList.orderDetail.title")}
                    </DialogTitle>

                    <DialogContent className="!bg-slate-100">
                      <DialogContentText
                        id="alert-dialog-description"
                        component="div"
                      >
                        {Modalloading ? (
                          <LoadingComponent />
                        ) : (
                          <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            className="flex flex-col space-y-1 p-1 w-[100%] h-[100%]"
                          >
                            <div className="w-[100%] justify-center text-center bg-gradient-to-r from-brand-blue-800 to-brand-blue-900 rounded-t-lg">
                              <span className="text-m text-white font-bold">
                                {t("orderList.orderDetail.orderNumber", {
                                  id: pollid,
                                })}
                              </span>
                              <div className="flex flex-col w-[100%] p-1 h-auto bg-slate-50 rounded-b-lg border-[1px] border-slate-300">
                                <div className="flex flex-row w-[100%] justify-between">
                                  <div className="w-[50] p-1">
                                    <span className="text-xs text-slate-600 font-thin">
                                      {t("orderList.orderDetail.roundDate", {
                                        date: moment(resdate).format("ll"),
                                      })}
                                    </span>
                                  </div>
                                  <div className="flex flex-row p-2 space-x-2 w-[50]">
                                    <span className="text-xs text-emerald-600 font-bold">
                                      {t("orderList.orderDetail.transactedAt", {
                                        date: moment(betdate).format("ll"),
                                      })}
                                    </span>
                                  </div>
                                </div>
                                <div className="flex flex-row w-[100%] border-slate-300 border-t-[1px]">
                                  <div className="flex flex-col w-full h-auto justify-center items-center md:px-20 py-5 border-r-[1px] text-center border-slate-300 hover:bg-white transition-colors">
                                    <span className="text-slate-500 text-xs font-thin">
                                      {t("orderList.orderDetail.totalBet")}
                                    </span>
                                    <span className="text-brand-gold-600 text-sm font-bold">
                                      {currency?.symbol} {totalbet}
                                    </span>
                                  </div>
                                  <div className="flex flex-col w-full h-auto justify-center items-center md:px-20 py-5 text-center hover:bg-white transition-colors">
                                    <span className="text-slate-500 text-xs font-thin">
                                      {t("orderList.orderDetail.totalWinLoss")}
                                    </span>
                                    <span className="text-slate-800 text-sm font-bold">
                                      {currency?.symbol} {totalwin}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="w-[100%] flex flex-col gap-3">
                              {Object.entries(
                                orderid.reduce((groups, row) => {
                                  const groupName =
                                    rewardTypeInfo[row.bet_type]?.groupName ||
                                    t("orderList.orderDetail.otherGroup");
                                  (groups[groupName] =
                                    groups[groupName] || []).push(row);
                                  return groups;
                                }, {}),
                              ).map(([groupName, rows]) => (
                                <div
                                  key={groupName}
                                  className="flex flex-col gap-2"
                                >
                                  <div className="inline-flex w-fit items-center bg-gradient-to-r from-brand-blue-600 to-brand-blue-800 rounded-full px-3 py-1 shadow-sm">
                                    <span className="text-brand-gold-200 font-bold text-xs tracking-wide">
                                      {groupName}
                                    </span>
                                  </div>
                                  <div className="flex flex-wrap gap-2">
                                    {rows.map((row) => (
                                      <div
                                        key={row.id}
                                        className={
                                          "flex flex-col w-[calc(50%-4px)] md:h-[130px space-y-2 bg-white border-[1px] shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all rounded-lg overflow-hidden border-l-4 " +
                                          (row.result === "win"
                                            ? "border-slate-200 border-l-emerald-500"
                                            : row.result === "lose"
                                              ? "border-slate-200 border-l-red-500"
                                              : row.result === "cancel"
                                                ? "border-slate-200 border-l-slate-400"
                                                : "border-slate-200 border-l-amber-400")
                                        }
                                      >
                                        <div className="w-[100%] flex flex-row justify-between items-center p-1 px-2 text-center bg-slate-100 border-b-[1px] border-slate-200">
                                          <span className="text-xs text-slate-600 font-thin">
                                            {t(
                                              "orderList.orderDetail.itemNumber",
                                              {
                                                id: row.id,
                                              },
                                            )}
                                          </span>
                                          {row.result === "wait_result" && (
                                            <div className="inline-flex flex-row border-white text-center shadow-sm justify-center border-[1px] w-auto px-2 py-0.5 h-auto rounded-full bg-gradient-to-r from-amber-400 to-amber-500">
                                              <span className="text-white font-bold text-[11px]">
                                                {t(
                                                  "orderList.modalStatus.waitResult",
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          {row.result === "lose" && (
                                            <div className="inline-flex flex-row shadow-sm border-white text-center justify-center border-[1px] w-auto px-2 py-0.5 h-auto rounded-full bg-gradient-to-r from-rose-500 to-red-600">
                                              <span className="text-white font-bold text-[14px]">
                                                {t(
                                                  "orderList.modalStatus.lose",
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          {row.result === "cancel" && (
                                            <div className="inline-flex flex-row shadow-sm border-white text-center justify-center border-[1px] w-auto px-2 py-0.5 h-auto rounded-full bg-gradient-to-r from-slate-500 to-slate-600">
                                              <span className="text-white font-bold text-[14px]">
                                                {t(
                                                  "orderList.modalStatus.cancel",
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          {row.result === "win" && (
                                            <div className="inline-flex flex-row shadow-sm border-white text-center justify-center border-[1px] w-auto px-2 py-0.5 h-auto rounded-full bg-gradient-to-r from-emerald-400 to-green-600">
                                              <span className="text-white font-bold text-[14px]">
                                                {t("orderList.modalStatus.win")}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                        <div className="w-[100%] h-auto flex flex-row p-1 text-center bg-white">
                                          <div className="w-[100%] h-auto justify-center items-center flex flex-row ">
                                            <div className="flex flex-col w-full h-auto justify-center items-center p-2 text-center bg-gradient-to-br from-brand-blue-50 to-brand-blue-100 border border-brand-blue-100 rounded-lg mr-1">
                                              <span className="text-xl text-brand-blue-700 font-extrabold tracking-wide">
                                                {formatBetNumber(row.number)}
                                              </span>
                                              <span className="text-slate-500 text-xs font-semibold">
                                                {rewardTypeInfo[row.bet_type]
                                                  ?.name || row.bet_type}
                                              </span>
                                            </div>
                                            <div className="flex flex-col w-full h-auto justify-center items-center px-2 text-center border-l-[1px] border-slate-200">
                                              <div className="w-[100%] flex flex-row justify-between border-b-[1px] border-slate-200">
                                                <div>
                                                  <span className="text-[14px] text-slate-500 font-thin">
                                                    {t(
                                                      "orderList.orderDetail.resultNumber",
                                                    )}
                                                  </span>
                                                </div>

                                                <div className="flex items-center">
                                                  <span className="text-[20px] text-brand-gold-600 font-bold">
                                                    {row.result_number}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="w-[100%] flex flex-row justify-between border-b-[1px] border-slate-200">
                                                <div>
                                                  <span className="text-[14px] text-slate-500 font-thin">
                                                    {t(
                                                      "orderList.orderDetail.payoutRate",
                                                    )}
                                                  </span>
                                                </div>
                                                <div>
                                                  <span className="text-[14px] text-slate-700 font-semibold">
                                                    {currency?.symbol} {row.bet_payrate}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="w-[100%] flex flex-row justify-between p-1 px-2 text-center bg-slate-50 border-t-[1px] border-slate-200">
                                          <span className="text-xs text-slate-500 font-thin">
                                            {t(
                                              "orderList.orderDetail.betAmount",
                                              {
                                                amount: row.bet_amout,
                                              },
                                            )}
                                          </span>
                                          <div className="flex flex-row ">
                                            <span className="text-emerald-600 font-bold text-[14px]">
                                              {t(
                                                "orderList.orderDetail.winAmount",
                                                { amount: row.win_amout },
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </motion.div>
                        )}
                      </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                      <button
                        onClick={handleClose}
                        className="bg-gradient-to-r from-brand-blue-700 to-brand-blue-900 hover:from-brand-blue-600 hover:to-brand-blue-800 text-white font-bold py-2 px-4 rounded-lg shadow-sm transition-colors"
                      >
                        {t("orderList.orderDetail.close")}
                      </button>
                    </DialogActions>
                  </Dialog>
                </div>
              )}
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  );
}
